<template>
  <div id="wiezijnwij" class="d-flex flex-column w-100">
    <div
      id="content"
      style="display: flex; align-items: center; justify-content: center; margin-left: 30px"
    >
      <div>
        <div class="d-flex flex-wrap" style="max-width: 75vw;">
          <div>
            <img
              src="/images/home/groep_rij.jpg"
              :width="width"
              style="transform: rotate(-23deg); max-width: 100%;"
              alt=""
            />
          </div>
          <div>
            <img
              src="/images/home/groep_hoop.jpg"
              :width="width"
              style="transform: rotate(23deg); max-width: 100%;"
              alt=""
            />
          </div>
          <div>
            <img
              src="/images/home/read_bible.jpg"
              :width="width"
              style="transform: rotate(8deg); max-width: 100%;"
              alt=""
            />
          </div>
          <div>
            <img
              src="/images/home/sjor.jpg"
              :width="width"
              style="transform: rotate(-42deg); max-width: 100%;"
              alt=""
            />
          </div>
        </div>
        <div class="d-flex flex-wrap" style="max-width: 75vw;">
          <div>
            <img
              src="/images/home/Bijbel.jpg"
              :width="width"
              style="transform: rotate(7deg); max-width: 100%;"
              alt=""
            />
          </div>
          <div>
            <img
              src="/images/home/touwtrekken.jpg"
              :width="width"
              style="transform: rotate(-12deg); max-width: 100%;"
              alt=""
            />
          </div>
          <div>
            <img
              src="/images/home/Bijbel_met_sticker.jpg"
              :width="width"
              style="transform: rotate(27deg); max-width: 100%;"
              alt=""
            />
          </div>
          <div>
            <img
              src="/images/home/piramide.jpg"
              :width="width"
              style="transform: rotate(-4deg); max-width: 100%;"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div id="logos"><logos /></div>
  </div>
</template>

<script>
import logos from '@/components/wiezijnwij/Samenwerking.vue';

export default {
  name: 'wiezijnwij',
  components: { logos },
  data() {
    return {
      width: '250',
    };
  },
};
</script>
